import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_REQUEST,
  USER_REGISTER_FAIL,
  USER_DETAIL_FAIL,
  USER_DETAIL_REQUEST,
  USER_DETAIL_SUCCESS,
  USER_CHANGE_PASSWORD_FAIL,
  USER_CHANGE_PASSWORD_REQUEST,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_UPDATE_PROFILE_PICTURE_FAIL,
  USER_UPDATE_PROFILE_PICTURE_REQUEST,
  USER_UPDATE_PROFILE_PICTURE_SUCCESS,
  USER_RESEND_EMAIL_FAIL,
  USER_RESEND_EMAIL_REQUEST,
  USER_RESEND_EMAIL_SUCCESS,
  USER_REGISTER_WITH_PASSWORD_FAIL,
  USER_REGISTER_WITH_PASSWORD_REQUEST,
  USER_REGISTER_WITH_PASSWORD_SUCCESS,
} from "../../types/user/authTypes";

export const userLoginReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userInfo: payload,
        error: "",
      };
    case USER_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        userInfo: {},
      };
    case USER_LOGOUT:
      return {
        userInfo: null,
      };
    default:
      return state;
  }
};

export const userRegisterReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        userInfo: payload,
        error: "",
      };
    case USER_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        userInfo: null,
        error: payload,
      };
    case USER_LOGOUT:
      return {
        userInfo: null,
      };
    default:
      return state;
  }
};

export const userRegisterWithPassReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_REGISTER_WITH_PASSWORD_REQUEST:
      return {
        ...state,
        userLoading: true,
      };
    case USER_REGISTER_WITH_PASSWORD_SUCCESS:
      return {
        ...state,
        userLoading: false,
        userInfo: payload,
        userError: "",
      };
    case USER_REGISTER_WITH_PASSWORD_FAIL:
      return {
        ...state,
        userLoading: false,
        userInfo: null,
        userError: payload,
      };
    case USER_LOGOUT:
      return {
        userInfo: null,
      };
    default:
      return state;
  }
};

export const userDetailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
      };
    case USER_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        detailUserInfo: payload,
        detailError: "",
      };
    case USER_DETAIL_FAIL:
      return {
        ...state,
        detailLoading: false,
        detailUserInfo: null,
        detailError: payload,
      };
    default:
      return state;
  }
};

export const userChangePasswordReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePassLoading: true,
      };
    case USER_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassLoading: false,
        changePassUserInfo: payload,
        changePassError: "",
      };
    case USER_CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        changePassLoading: false,
        changePassUserInfo: null,
        changePassError: payload,
      };
    default:
      return state;
  }
};

export const userUpdateProfilePicReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_UPDATE_PROFILE_PICTURE_REQUEST:
      return {
        ...state,
        userProfileLoading: true,
      };
    case USER_UPDATE_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        userProfileLoading: false,
        userProfileInfo: payload,
        userProfileError: "",
      };
    case USER_UPDATE_PROFILE_PICTURE_FAIL:
      return {
        ...state,
        userProfileLoading: false,
        userProfileInfo: null,
        userProfileError: payload,
      };
    default:
      return state;
  }
};

export const userResendEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_RESEND_EMAIL_REQUEST:
      return {
        ...state,
        emailResendLoading: true,
      };
    case USER_RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailResendLoading: false,
        emailResendInfo: payload,
        emailResendError: "",
      };
    case USER_RESEND_EMAIL_FAIL:
      return {
        ...state,
        emailResendLoading: false,
        emailResendInfo: null,
        emailResendError: payload,
      };
    default:
      return state;
  }
};
